import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { EditSectionTitleComponent } from '@modeso/aumico-lib-core-fe';
import { IStyleOptions } from '@modeso/types__aumico-lib-annualreport-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import Debug from 'debug';
import { cloneDeep } from 'lodash-es';
import { filter, map } from 'rxjs';
import { PrintUsingPdfTronDto } from '../../../dtos/print-using-pdf-tron.dto';
import { ISectionData } from '../../../interfaces/pdf-tron/section-data.interface';
import { AnnualReportProvider } from '../../../provider/annualReport.provider';

const debug = Debug('aumico:aumico-lib-annualreport-fe:appropriationOfProfitPage');

@UntilDestroy()
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'aumico-annualReport-appropriation-of-profit-swiss-print-preview-page',
    templateUrl: 'appropriation-swiss-print-preview.page.html',
    styleUrls: ['appropriation-swiss-print-preview.page.scss'],
})
export class AppropriationOfProfitSwissPrintPreviewPage implements OnInit {
    @Input() noPreviousData = false;

    @Input() stylePreferenceOptions: IStyleOptions | undefined;

    @Input() textColor: string;

    @Output() sectionTitleChanged: EventEmitter<string> = new EventEmitter<string>();

    public appropriationOfProfitSection: ISectionData | undefined;
    public sectionTitle: string | undefined;

    constructor(
        private readonly annualReportProvider: AnnualReportProvider,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        private dialog: MatDialog,
    ) {
        this.addSvgIcon('aumico-pattern-icon-edit-write');
    }

    ngOnInit(): void {
        this.annualReportProvider
            .getPrintView$()
            .pipe(
                filter(
                    (printViewData: PrintUsingPdfTronDto) => printViewData != null && printViewData.data.aop != null,
                ),
                map((printViewData: PrintUsingPdfTronDto) => printViewData.data.aop),
            )
            .subscribe((data) => {
                this.appropriationOfProfitSection = cloneDeep<ISectionData>(data);
                this.sectionTitle = data.title;
            });
    }

    public editSectionTitle(): void {
        const dialogRef = this.dialog.open<EditSectionTitleComponent, string, string | undefined>(
            EditSectionTitleComponent,
            {
                disableClose: false,
                panelClass: 'custom-modalbox',
                data: this.sectionTitle,
            },
        );

        dialogRef
            .afterClosed()
            .pipe(untilDestroyed(this))
            .subscribe((result) => {
                if (result != null) {
                    this.sectionTitle = result;
                    this.sectionTitleChanged.emit(result);
                }
            });
    }

    private addSvgIcon(name: string): void {
        this.matIconRegistry.addSvgIcon(
            name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${name}.svg`),
        );
    }
}
